// A spinner for the content area of a layout while a lazy route chunk loads.
//
// Without a Suspense boundary inside the layout, the only boundary is the one
// around <Routes>: when a nested page suspends, React hides the WHOLE layout
// (header, tabs, everything) until the chunk arrives — a blank flash of
// ~300ms on every first visit of a tab. With this boundary around the Outlet,
// the shell stays put and only the content area spins.
export function RouteFallback() {
  return (
    <div className="flex items-center justify-center py-24" role="status" aria-live="polite">
      <div className="border-primary h-6 w-6 animate-spin rounded-full border-2 border-t-transparent" />
    </div>
  );
}
